import styled from 'styled-components';

export const BuyButton = styled.button`
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: #00ab6b !important;
  border: 1px solid #00ab6b !important;
  border-radius: 4px;
  width: 100%;

  padding: 4px 15px;
  margin: 16px 0 0;
  height: 36px;
  font-weight: bold;
  color: #ffffff !important;
`;
